"use strict";
// @generated by protoc-gen-es v1.10.0 with parameter "target=ts,import_extension=none"
// @generated from file spwn/goods/v1/cms_common.proto (package spwn.goods.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
Object.defineProperty(exports, "__esModule", { value: true });
exports.CMSGoods = exports.CMSGoodsVariantSelfShipping = exports.CMSGoodsVariantSelfShippingImage = exports.CMSGoodsSelfShippingShippingSettingMadeToStock = exports.CMSGoodsSelfShippingShippingSettingMadeToOrder = exports.CMSGoodsVariantDigital_File = exports.CMSGoodsVariantDigital = exports.CMSGoodsVariantImage = exports.CMSGoodsVariantDigitalImage = exports.CMSGoodsImage = exports.CMSGoodsSelfShipping = exports.CMSGoodsDigital = exports.CMSGoodsStatus = exports.CMSGoodsType = exports.CMSGoodsVariantSelfShippingType = exports.CMSGoodsVariantDigitalType = exports.CMSInventoryPolicy = exports.CMSGoodsSalesType = void 0;
const protobuf_1 = require("@bufbuild/protobuf");
/**
 * @generated from enum spwn.goods.v1.CMSGoodsSalesType
 */
var CMSGoodsSalesType;
(function (CMSGoodsSalesType) {
    /**
     * @generated from enum value: CMS_GOODS_SALES_TYPE_UNSPECIFIED = 0;
     */
    CMSGoodsSalesType[CMSGoodsSalesType["CMS_GOODS_SALES_TYPE_UNSPECIFIED"] = 0] = "CMS_GOODS_SALES_TYPE_UNSPECIFIED";
    /**
     * 通常販売
     *
     * @generated from enum value: CMS_GOODS_SALES_TYPE_PERMANENT = 1;
     */
    CMSGoodsSalesType[CMSGoodsSalesType["CMS_GOODS_SALES_TYPE_PERMANENT"] = 1] = "CMS_GOODS_SALES_TYPE_PERMANENT";
    /**
     * 受注販売
     *
     * @generated from enum value: CMS_GOODS_SALES_TYPE_BUILT_TO_ORDER = 2;
     */
    CMSGoodsSalesType[CMSGoodsSalesType["CMS_GOODS_SALES_TYPE_BUILT_TO_ORDER"] = 2] = "CMS_GOODS_SALES_TYPE_BUILT_TO_ORDER";
})(CMSGoodsSalesType || (exports.CMSGoodsSalesType = CMSGoodsSalesType = {}));
// Retrieve enum metadata with: proto3.getEnumType(CMSGoodsSalesType)
protobuf_1.proto3.util.setEnumType(CMSGoodsSalesType, "spwn.goods.v1.CMSGoodsSalesType", [
    { no: 0, name: "CMS_GOODS_SALES_TYPE_UNSPECIFIED" },
    { no: 1, name: "CMS_GOODS_SALES_TYPE_PERMANENT" },
    { no: 2, name: "CMS_GOODS_SALES_TYPE_BUILT_TO_ORDER" },
]);
/**
 * @generated from enum spwn.goods.v1.CMSInventoryPolicy
 */
var CMSInventoryPolicy;
(function (CMSInventoryPolicy) {
    /**
     * @generated from enum value: CMS_INVENTORY_POLICY_UNSPECIFIED = 0;
     */
    CMSInventoryPolicy[CMSInventoryPolicy["CMS_INVENTORY_POLICY_UNSPECIFIED"] = 0] = "CMS_INVENTORY_POLICY_UNSPECIFIED";
    /**
     * 在庫がなくなった場合、購入を拒否する
     *
     * @generated from enum value: CMS_INVENTORY_POLICY_DENY = 1;
     */
    CMSInventoryPolicy[CMSInventoryPolicy["CMS_INVENTORY_POLICY_DENY"] = 1] = "CMS_INVENTORY_POLICY_DENY";
    /**
     * 在庫がなくなった場合、購入を続けることができる
     *
     * @generated from enum value: CMS_INVENTORY_POLICY_CONTINUE = 2;
     */
    CMSInventoryPolicy[CMSInventoryPolicy["CMS_INVENTORY_POLICY_CONTINUE"] = 2] = "CMS_INVENTORY_POLICY_CONTINUE";
})(CMSInventoryPolicy || (exports.CMSInventoryPolicy = CMSInventoryPolicy = {}));
// Retrieve enum metadata with: proto3.getEnumType(CMSInventoryPolicy)
protobuf_1.proto3.util.setEnumType(CMSInventoryPolicy, "spwn.goods.v1.CMSInventoryPolicy", [
    { no: 0, name: "CMS_INVENTORY_POLICY_UNSPECIFIED" },
    { no: 1, name: "CMS_INVENTORY_POLICY_DENY" },
    { no: 2, name: "CMS_INVENTORY_POLICY_CONTINUE" },
]);
/**
 * @generated from enum spwn.goods.v1.CMSGoodsVariantDigitalType
 */
var CMSGoodsVariantDigitalType;
(function (CMSGoodsVariantDigitalType) {
    /**
     * @generated from enum value: CMS_GOODS_VARIANT_DIGITAL_TYPE_UNSPECIFIED = 0;
     */
    CMSGoodsVariantDigitalType[CMSGoodsVariantDigitalType["CMS_GOODS_VARIANT_DIGITAL_TYPE_UNSPECIFIED"] = 0] = "CMS_GOODS_VARIANT_DIGITAL_TYPE_UNSPECIFIED";
    /**
     * @generated from enum value: CMS_GOODS_VARIANT_DIGITAL_TYPE_DIGITAL = 1;
     */
    CMSGoodsVariantDigitalType[CMSGoodsVariantDigitalType["CMS_GOODS_VARIANT_DIGITAL_TYPE_DIGITAL"] = 1] = "CMS_GOODS_VARIANT_DIGITAL_TYPE_DIGITAL";
})(CMSGoodsVariantDigitalType || (exports.CMSGoodsVariantDigitalType = CMSGoodsVariantDigitalType = {}));
// Retrieve enum metadata with: proto3.getEnumType(CMSGoodsVariantDigitalType)
protobuf_1.proto3.util.setEnumType(CMSGoodsVariantDigitalType, "spwn.goods.v1.CMSGoodsVariantDigitalType", [
    { no: 0, name: "CMS_GOODS_VARIANT_DIGITAL_TYPE_UNSPECIFIED" },
    { no: 1, name: "CMS_GOODS_VARIANT_DIGITAL_TYPE_DIGITAL" },
]);
/**
 * @generated from enum spwn.goods.v1.CMSGoodsVariantSelfShippingType
 */
var CMSGoodsVariantSelfShippingType;
(function (CMSGoodsVariantSelfShippingType) {
    /**
     * @generated from enum value: CMS_GOODS_VARIANT_SELF_SHIPPING_TYPE_UNSPECIFIED = 0;
     */
    CMSGoodsVariantSelfShippingType[CMSGoodsVariantSelfShippingType["CMS_GOODS_VARIANT_SELF_SHIPPING_TYPE_UNSPECIFIED"] = 0] = "CMS_GOODS_VARIANT_SELF_SHIPPING_TYPE_UNSPECIFIED";
    /**
     * @generated from enum value: CMS_GOODS_VARIANT_SELF_SHIPPING_TYPE_SELF_SHIPPING = 1;
     */
    CMSGoodsVariantSelfShippingType[CMSGoodsVariantSelfShippingType["CMS_GOODS_VARIANT_SELF_SHIPPING_TYPE_SELF_SHIPPING"] = 1] = "CMS_GOODS_VARIANT_SELF_SHIPPING_TYPE_SELF_SHIPPING";
})(CMSGoodsVariantSelfShippingType || (exports.CMSGoodsVariantSelfShippingType = CMSGoodsVariantSelfShippingType = {}));
// Retrieve enum metadata with: proto3.getEnumType(CMSGoodsVariantSelfShippingType)
protobuf_1.proto3.util.setEnumType(CMSGoodsVariantSelfShippingType, "spwn.goods.v1.CMSGoodsVariantSelfShippingType", [
    { no: 0, name: "CMS_GOODS_VARIANT_SELF_SHIPPING_TYPE_UNSPECIFIED" },
    { no: 1, name: "CMS_GOODS_VARIANT_SELF_SHIPPING_TYPE_SELF_SHIPPING" },
]);
/**
 * @generated from enum spwn.goods.v1.CMSGoodsType
 */
var CMSGoodsType;
(function (CMSGoodsType) {
    /**
     * @generated from enum value: CMS_GOODS_TYPE_UNSPECIFIED = 0;
     */
    CMSGoodsType[CMSGoodsType["CMS_GOODS_TYPE_UNSPECIFIED"] = 0] = "CMS_GOODS_TYPE_UNSPECIFIED";
    /**
     * @generated from enum value: CMS_GOODS_TYPE_DIGITAL = 1;
     */
    CMSGoodsType[CMSGoodsType["CMS_GOODS_TYPE_DIGITAL"] = 1] = "CMS_GOODS_TYPE_DIGITAL";
    /**
     * @generated from enum value: CMS_GOODS_TYPE_SELF_SHIPPING = 2;
     */
    CMSGoodsType[CMSGoodsType["CMS_GOODS_TYPE_SELF_SHIPPING"] = 2] = "CMS_GOODS_TYPE_SELF_SHIPPING";
})(CMSGoodsType || (exports.CMSGoodsType = CMSGoodsType = {}));
// Retrieve enum metadata with: proto3.getEnumType(CMSGoodsType)
protobuf_1.proto3.util.setEnumType(CMSGoodsType, "spwn.goods.v1.CMSGoodsType", [
    { no: 0, name: "CMS_GOODS_TYPE_UNSPECIFIED" },
    { no: 1, name: "CMS_GOODS_TYPE_DIGITAL" },
    { no: 2, name: "CMS_GOODS_TYPE_SELF_SHIPPING" },
]);
/**
 * @generated from enum spwn.goods.v1.CMSGoodsStatus
 */
var CMSGoodsStatus;
(function (CMSGoodsStatus) {
    /**
     * @generated from enum value: CMS_GOODS_STATUS_UNSPECIFIED = 0;
     */
    CMSGoodsStatus[CMSGoodsStatus["CMS_GOODS_STATUS_UNSPECIFIED"] = 0] = "CMS_GOODS_STATUS_UNSPECIFIED";
    /**
     * 公開
     *
     * @generated from enum value: CMS_GOODS_STATUS_ACTIVE = 1;
     */
    CMSGoodsStatus[CMSGoodsStatus["CMS_GOODS_STATUS_ACTIVE"] = 1] = "CMS_GOODS_STATUS_ACTIVE";
    /**
     * 準備中
     *
     * @generated from enum value: CMS_GOODS_STATUS_DRAFT = 2;
     */
    CMSGoodsStatus[CMSGoodsStatus["CMS_GOODS_STATUS_DRAFT"] = 2] = "CMS_GOODS_STATUS_DRAFT";
    /**
     * アーカイブ
     *
     * @generated from enum value: CMS_GOODS_STATUS_ARCHIVED = 3;
     */
    CMSGoodsStatus[CMSGoodsStatus["CMS_GOODS_STATUS_ARCHIVED"] = 3] = "CMS_GOODS_STATUS_ARCHIVED";
})(CMSGoodsStatus || (exports.CMSGoodsStatus = CMSGoodsStatus = {}));
// Retrieve enum metadata with: proto3.getEnumType(CMSGoodsStatus)
protobuf_1.proto3.util.setEnumType(CMSGoodsStatus, "spwn.goods.v1.CMSGoodsStatus", [
    { no: 0, name: "CMS_GOODS_STATUS_UNSPECIFIED" },
    { no: 1, name: "CMS_GOODS_STATUS_ACTIVE" },
    { no: 2, name: "CMS_GOODS_STATUS_DRAFT" },
    { no: 3, name: "CMS_GOODS_STATUS_ARCHIVED" },
]);
/**
 * @generated from message spwn.goods.v1.CMSGoodsDigital
 */
class CMSGoodsDigital extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string goods_id = 1;
         */
        this.goodsId = "";
        /**
         * 種別
         *
         * @generated from field: spwn.goods.v1.CMSGoodsType type = 2;
         */
        this.type = CMSGoodsType.CMS_GOODS_TYPE_UNSPECIFIED;
        /**
         * 公開ステータス
         *
         * @generated from field: spwn.goods.v1.CMSGoodsStatus status = 3;
         */
        this.status = CMSGoodsStatus.CMS_GOODS_STATUS_UNSPECIFIED;
        /**
         * グッズ名
         *
         * @generated from field: string name = 4;
         */
        this.name = "";
        /**
         * 説明
         *
         * @generated from field: string body = 5;
         */
        this.body = "";
        /**
         * 価格
         *
         * @generated from field: double price = 6;
         */
        this.price = 0;
        /**
         * 公開設定が有効な場合、販売開始日の前にアクセス可能か
         *
         * @generated from field: bool enable_access_before_sales_period = 9;
         */
        this.enableAccessBeforeSalesPeriod = false;
        /**
         * グッズのイメージ画像
         *
         * @generated from field: repeated spwn.goods.v1.CMSGoodsImage images = 10;
         */
        this.images = [];
        /**
         * 並び順 Desc
         *
         * @generated from field: int32 priority = 12;
         */
        this.priority = 0;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSGoodsDigital().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSGoodsDigital().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSGoodsDigital().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSGoodsDigital, a, b);
    }
}
exports.CMSGoodsDigital = CMSGoodsDigital;
CMSGoodsDigital.runtime = protobuf_1.proto3;
CMSGoodsDigital.typeName = "spwn.goods.v1.CMSGoodsDigital";
CMSGoodsDigital.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "goods_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "type", kind: "enum", T: protobuf_1.proto3.getEnumType(CMSGoodsType) },
    { no: 3, name: "status", kind: "enum", T: protobuf_1.proto3.getEnumType(CMSGoodsStatus) },
    { no: 4, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "body", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "price", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 7, name: "sales_period_started_at", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 8, name: "sales_period_ended_at", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 9, name: "enable_access_before_sales_period", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 10, name: "images", kind: "message", T: CMSGoodsImage, repeated: true },
    { no: 12, name: "priority", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
]);
/**
 * @generated from message spwn.goods.v1.CMSGoodsSelfShipping
 */
class CMSGoodsSelfShipping extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string goods_id = 1;
         */
        this.goodsId = "";
        /**
         * 種別
         *
         * @generated from field: spwn.goods.v1.CMSGoodsType type = 2;
         */
        this.type = CMSGoodsType.CMS_GOODS_TYPE_UNSPECIFIED;
        /**
         * 公開ステータス
         *
         * @generated from field: spwn.goods.v1.CMSGoodsStatus status = 3;
         */
        this.status = CMSGoodsStatus.CMS_GOODS_STATUS_UNSPECIFIED;
        /**
         * グッズ名
         *
         * @generated from field: string name = 4;
         */
        this.name = "";
        /**
         * 説明
         *
         * @generated from field: string body = 5;
         */
        this.body = "";
        /**
         * 価格
         *
         * @generated from field: double price = 6;
         */
        this.price = 0;
        /**
         * 公開設定が有効な場合、販売開始日の前にアクセス可能か
         *
         * @generated from field: bool enable_access_before_sales_period = 9;
         */
        this.enableAccessBeforeSalesPeriod = false;
        /**
         * グッズのイメージ画像
         *
         * @generated from field: repeated spwn.goods.v1.CMSGoodsImage images = 10;
         */
        this.images = [];
        /**
         * 並び順 Desc
         *
         * @generated from field: int32 priority = 12;
         */
        this.priority = 0;
        /**
         * 発送設定
         *
         * @generated from oneof spwn.goods.v1.CMSGoodsSelfShipping.shipping_setting
         */
        this.shippingSetting = { case: undefined };
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSGoodsSelfShipping().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSGoodsSelfShipping().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSGoodsSelfShipping().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSGoodsSelfShipping, a, b);
    }
}
exports.CMSGoodsSelfShipping = CMSGoodsSelfShipping;
CMSGoodsSelfShipping.runtime = protobuf_1.proto3;
CMSGoodsSelfShipping.typeName = "spwn.goods.v1.CMSGoodsSelfShipping";
CMSGoodsSelfShipping.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "goods_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "type", kind: "enum", T: protobuf_1.proto3.getEnumType(CMSGoodsType) },
    { no: 3, name: "status", kind: "enum", T: protobuf_1.proto3.getEnumType(CMSGoodsStatus) },
    { no: 4, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "body", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "price", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 7, name: "sales_period_started_at", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 8, name: "sales_period_ended_at", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 9, name: "enable_access_before_sales_period", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 10, name: "images", kind: "message", T: CMSGoodsImage, repeated: true },
    { no: 12, name: "priority", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 13, name: "made_to_order", kind: "message", T: CMSGoodsSelfShippingShippingSettingMadeToOrder, oneof: "shipping_setting" },
    { no: 14, name: "made_to_stock", kind: "message", T: CMSGoodsSelfShippingShippingSettingMadeToStock, oneof: "shipping_setting" },
]);
/**
 * @generated from message spwn.goods.v1.CMSGoodsImage
 */
class CMSGoodsImage extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string goods_image_id = 1;
         */
        this.goodsImageId = "";
        /**
         * グッズ画像のURL
         *
         * @generated from field: string src = 2;
         */
        this.src = "";
        /**
         * @generated from field: int32 position = 3;
         */
        this.position = 0;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSGoodsImage().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSGoodsImage().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSGoodsImage().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSGoodsImage, a, b);
    }
}
exports.CMSGoodsImage = CMSGoodsImage;
CMSGoodsImage.runtime = protobuf_1.proto3;
CMSGoodsImage.typeName = "spwn.goods.v1.CMSGoodsImage";
CMSGoodsImage.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "goods_image_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "src", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "position", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
]);
/**
 * @generated from message spwn.goods.v1.CMSGoodsVariantDigitalImage
 */
class CMSGoodsVariantDigitalImage extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string src = 1;
         */
        this.src = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSGoodsVariantDigitalImage().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSGoodsVariantDigitalImage().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSGoodsVariantDigitalImage().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSGoodsVariantDigitalImage, a, b);
    }
}
exports.CMSGoodsVariantDigitalImage = CMSGoodsVariantDigitalImage;
CMSGoodsVariantDigitalImage.runtime = protobuf_1.proto3;
CMSGoodsVariantDigitalImage.typeName = "spwn.goods.v1.CMSGoodsVariantDigitalImage";
CMSGoodsVariantDigitalImage.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "src", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.goods.v1.CMSGoodsVariantImage
 */
class CMSGoodsVariantImage extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string src = 1;
         */
        this.src = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSGoodsVariantImage().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSGoodsVariantImage().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSGoodsVariantImage().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSGoodsVariantImage, a, b);
    }
}
exports.CMSGoodsVariantImage = CMSGoodsVariantImage;
CMSGoodsVariantImage.runtime = protobuf_1.proto3;
CMSGoodsVariantImage.typeName = "spwn.goods.v1.CMSGoodsVariantImage";
CMSGoodsVariantImage.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "src", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.goods.v1.CMSGoodsVariantDigital
 */
class CMSGoodsVariantDigital extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string goods_variant_digital_id = 1;
         */
        this.goodsVariantDigitalId = "";
        /**
         * バリエーションの種別
         *
         * @generated from field: spwn.goods.v1.CMSGoodsVariantDigitalType type = 2;
         */
        this.type = CMSGoodsVariantDigitalType.CMS_GOODS_VARIANT_DIGITAL_TYPE_UNSPECIFIED;
        /**
         * バリエーションの名前
         *
         * @generated from field: string name = 3;
         */
        this.name = "";
        /**
         * 在庫数
         *
         * @generated from field: int32 inventory_quantity = 5;
         */
        this.inventoryQuantity = 0;
        /**
         * 在庫数がなくなった場合の振る舞い
         *
         * @generated from field: spwn.goods.v1.CMSInventoryPolicy inventory_policy = 6;
         */
        this.inventoryPolicy = CMSInventoryPolicy.CMS_INVENTORY_POLICY_UNSPECIFIED;
        /**
         * @generated from field: repeated spwn.goods.v1.CMSGoodsVariantDigital.File files = 7;
         */
        this.files = [];
        /**
         * 並び順 1から昇順
         *
         * @generated from field: int32 position = 8;
         */
        this.position = 0;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSGoodsVariantDigital().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSGoodsVariantDigital().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSGoodsVariantDigital().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSGoodsVariantDigital, a, b);
    }
}
exports.CMSGoodsVariantDigital = CMSGoodsVariantDigital;
CMSGoodsVariantDigital.runtime = protobuf_1.proto3;
CMSGoodsVariantDigital.typeName = "spwn.goods.v1.CMSGoodsVariantDigital";
CMSGoodsVariantDigital.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "goods_variant_digital_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "type", kind: "enum", T: protobuf_1.proto3.getEnumType(CMSGoodsVariantDigitalType) },
    { no: 3, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "image", kind: "message", T: CMSGoodsVariantDigitalImage },
    { no: 5, name: "inventory_quantity", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "inventory_policy", kind: "enum", T: protobuf_1.proto3.getEnumType(CMSInventoryPolicy) },
    { no: 7, name: "files", kind: "message", T: CMSGoodsVariantDigital_File, repeated: true },
    { no: 8, name: "position", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
]);
/**
 * デジタルグッズの実態で、ダウンロード可能なファイル
 *
 * @generated from message spwn.goods.v1.CMSGoodsVariantDigital.File
 */
class CMSGoodsVariantDigital_File extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string filename = 1;
         */
        this.filename = "";
        /**
         * @generated from field: string src = 2;
         */
        this.src = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSGoodsVariantDigital_File().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSGoodsVariantDigital_File().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSGoodsVariantDigital_File().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSGoodsVariantDigital_File, a, b);
    }
}
exports.CMSGoodsVariantDigital_File = CMSGoodsVariantDigital_File;
CMSGoodsVariantDigital_File.runtime = protobuf_1.proto3;
CMSGoodsVariantDigital_File.typeName = "spwn.goods.v1.CMSGoodsVariantDigital.File";
CMSGoodsVariantDigital_File.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "filename", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "src", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * 受注生産の発送設定
 *
 * @generated from message spwn.goods.v1.CMSGoodsSelfShippingShippingSettingMadeToOrder
 */
class CMSGoodsSelfShippingShippingSettingMadeToOrder extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * 送料
         *
         * @generated from field: double shipping_fee = 1;
         */
        this.shippingFee = 0;
        /**
         * 発送予定日
         *
         * @generated from field: int64 shipped_at = 2;
         */
        this.shippedAt = protobuf_1.protoInt64.zero;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSGoodsSelfShippingShippingSettingMadeToOrder().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSGoodsSelfShippingShippingSettingMadeToOrder().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSGoodsSelfShippingShippingSettingMadeToOrder().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSGoodsSelfShippingShippingSettingMadeToOrder, a, b);
    }
}
exports.CMSGoodsSelfShippingShippingSettingMadeToOrder = CMSGoodsSelfShippingShippingSettingMadeToOrder;
CMSGoodsSelfShippingShippingSettingMadeToOrder.runtime = protobuf_1.proto3;
CMSGoodsSelfShippingShippingSettingMadeToOrder.typeName = "spwn.goods.v1.CMSGoodsSelfShippingShippingSettingMadeToOrder";
CMSGoodsSelfShippingShippingSettingMadeToOrder.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "shipping_fee", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "shipped_at", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
]);
/**
 * 見込み生産の発送設定
 *
 * @generated from message spwn.goods.v1.CMSGoodsSelfShippingShippingSettingMadeToStock
 */
class CMSGoodsSelfShippingShippingSettingMadeToStock extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * 送料
         *
         * @generated from field: double shipping_fee = 1;
         */
        this.shippingFee = 0;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSGoodsSelfShippingShippingSettingMadeToStock().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSGoodsSelfShippingShippingSettingMadeToStock().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSGoodsSelfShippingShippingSettingMadeToStock().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSGoodsSelfShippingShippingSettingMadeToStock, a, b);
    }
}
exports.CMSGoodsSelfShippingShippingSettingMadeToStock = CMSGoodsSelfShippingShippingSettingMadeToStock;
CMSGoodsSelfShippingShippingSettingMadeToStock.runtime = protobuf_1.proto3;
CMSGoodsSelfShippingShippingSettingMadeToStock.typeName = "spwn.goods.v1.CMSGoodsSelfShippingShippingSettingMadeToStock";
CMSGoodsSelfShippingShippingSettingMadeToStock.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "shipping_fee", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "min_days_to_ship", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 3, name: "max_days_to_ship", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
]);
/**
 * @generated from message spwn.goods.v1.CMSGoodsVariantSelfShippingImage
 */
class CMSGoodsVariantSelfShippingImage extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string src = 1;
         */
        this.src = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSGoodsVariantSelfShippingImage().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSGoodsVariantSelfShippingImage().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSGoodsVariantSelfShippingImage().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSGoodsVariantSelfShippingImage, a, b);
    }
}
exports.CMSGoodsVariantSelfShippingImage = CMSGoodsVariantSelfShippingImage;
CMSGoodsVariantSelfShippingImage.runtime = protobuf_1.proto3;
CMSGoodsVariantSelfShippingImage.typeName = "spwn.goods.v1.CMSGoodsVariantSelfShippingImage";
CMSGoodsVariantSelfShippingImage.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "src", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.goods.v1.CMSGoodsVariantSelfShipping
 */
class CMSGoodsVariantSelfShipping extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string goods_variant_self_shipping_id = 1;
         */
        this.goodsVariantSelfShippingId = "";
        /**
         * バリエーションの種別
         *
         * @generated from field: spwn.goods.v1.CMSGoodsVariantSelfShippingType type = 2;
         */
        this.type = CMSGoodsVariantSelfShippingType.CMS_GOODS_VARIANT_SELF_SHIPPING_TYPE_UNSPECIFIED;
        /**
         * バリエーションの名前
         *
         * @generated from field: string name = 3;
         */
        this.name = "";
        /**
         * 在庫数
         *
         * @generated from field: int32 inventory_quantity = 5;
         */
        this.inventoryQuantity = 0;
        /**
         * 在庫数がなくなった場合の振る舞い
         *
         * @generated from field: spwn.goods.v1.CMSInventoryPolicy inventory_policy = 6;
         */
        this.inventoryPolicy = CMSInventoryPolicy.CMS_INVENTORY_POLICY_UNSPECIFIED;
        /**
         * 並び順 1から昇順
         *
         * @generated from field: int32 position = 7;
         */
        this.position = 0;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSGoodsVariantSelfShipping().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSGoodsVariantSelfShipping().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSGoodsVariantSelfShipping().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSGoodsVariantSelfShipping, a, b);
    }
}
exports.CMSGoodsVariantSelfShipping = CMSGoodsVariantSelfShipping;
CMSGoodsVariantSelfShipping.runtime = protobuf_1.proto3;
CMSGoodsVariantSelfShipping.typeName = "spwn.goods.v1.CMSGoodsVariantSelfShipping";
CMSGoodsVariantSelfShipping.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "goods_variant_self_shipping_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "type", kind: "enum", T: protobuf_1.proto3.getEnumType(CMSGoodsVariantSelfShippingType) },
    { no: 3, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "image", kind: "message", T: CMSGoodsVariantSelfShippingImage },
    { no: 5, name: "inventory_quantity", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "inventory_policy", kind: "enum", T: protobuf_1.proto3.getEnumType(CMSInventoryPolicy) },
    { no: 7, name: "position", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
]);
/**
 * @generated from message spwn.goods.v1.CMSGoods
 */
class CMSGoods extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from oneof spwn.goods.v1.CMSGoods.data
         */
        this.data = { case: undefined };
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSGoods().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSGoods().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSGoods().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSGoods, a, b);
    }
}
exports.CMSGoods = CMSGoods;
CMSGoods.runtime = protobuf_1.proto3;
CMSGoods.typeName = "spwn.goods.v1.CMSGoods";
CMSGoods.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "digital", kind: "message", T: CMSGoodsDigital, oneof: "data" },
    { no: 2, name: "self_shipping", kind: "message", T: CMSGoodsSelfShipping, oneof: "data" },
]);
//# sourceMappingURL=cms_common_pb.js.map